import styled from "@emotion/styled";
import { Swiper, SwiperSlide } from "swiper/react";

import { fontRobotoCondensed, fontSourceSerif4 } from "shared/lib/styles";

export const Title = styled.div`
  padding-block-end: 10px;

  color: #000000;
  font-weight: 400;
  font-size: 28px;
  font-family: ${fontSourceSerif4};
  line-height: 90%;
  letter-spacing: -1.4px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  inline-size: 100%;
  padding-block-start: 12px;
  border-block-start: 1px #000000 solid;
`;

export const TabsContainer = styled.div`
  display: flex;

  inline-size: 100%;
`;

export const StyledSwiper = styled(Swiper)`
  margin: 0;
`;

export const StyledSwiperSlide = styled(SwiperSlide)`
  inline-size: auto;
  margin-inline-end: 8px;
`;

type TabProps = {
  $isActive: boolean;
};

export const Tab = styled.div<TabProps>`
  display: flex;

  padding-block: 8px;
  padding-inline: 12px;

  color: #000000;
  font-weight: 400;
  font-size: 14px;
  font-family: ${fontRobotoCondensed};
  font-style: normal;
  line-height: normal;
  white-space: nowrap;

  border: 1px solid ${props => (props.$isActive ? "#000000" : "transparent")};
  border-radius: 100px;

  background: rgba(69, 137, 255, 0.1);

  cursor: pointer;
`;
